import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./themes/default";
// Removed Amplify in GCP-only mode
import { NotificationContainer } from "./components/notification/NotificationContainer";
import { ModalManager } from "./context/ModalManager";
import ErrorBoundary from "./components/error-boundary/ErrorBoundary";
import { AuthenticatedUserContextProvider } from "./context/AdministratorContextProvider";
import { DialogManager } from "./context/DialogManager";
import { Outlet } from "react-router-dom";
import { AuthGate } from "./components/auth-gate/AuthGate";
import { useAdministratorStoreInit } from "./stores/useAdministratorStore";
import { useDocumentTitle } from "./hooks/useDocumentTitle";

// Amplify configuration removed as authentication is handled by Google Identity Platform

const queryClient = new QueryClient();

function App(): JSX.Element {
  useAdministratorStoreInit();
  useDocumentTitle();
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthenticatedUserContextProvider>
          <ThemeProvider theme={defaultTheme}>
            <AuthGate>
              <ModalManager>
                <DialogManager>
                  <ErrorBoundary>
                    <Outlet />
                  </ErrorBoundary>
                </DialogManager>
              </ModalManager>
              <NotificationContainer />
            </AuthGate>
          </ThemeProvider>
        </AuthenticatedUserContextProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
